// Mapa de colores

/**
 * Devuelve un summaryBox para la sección e nivel indicados.
 *
 * @param {"overall"|"nutrition"|"work"|"metabolic"|"activity"|"lifestyle"} type
 * @param {number} level
 * @returns {{ title: string, textRisk: string, boxColor: string, textColor: string }}
 */
export function getSummaryBox (type, level) {
  let title = "";
  let textRisk = "";
  let colorKey = "gray";
  const COLOR_MAP = {
    green: "#00BE9C",
    yellow: "#FFC107",
    red: "#FF5252",
    gray: "#AAAAAA"
  };
  console.log("levels")
  console.log(type)
  console.log(level)
  switch (type) {
    case "overall":
      title = "Resumen General";
      switch (level) {
        case 0:
          textRisk = "Calificación General Riesgo Bajo";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Calificación General Riesgo Medio";
          colorKey = "yellow";
          break;
        case 2:
          textRisk = "Calificación General Riesgo Alto";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    case "nutrition":
      title = "Índice de Masa Corporal";
      switch (level) {
        case 0:
          textRisk = "Normal";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Sobrepeso";
          colorKey = "yellow";
          break;
        case 2:
          textRisk = "Obesidad tipo 1";
          colorKey = "yellow";
          break;
        case 3:
          textRisk = "Obesidad tipo 2";
          colorKey = "red";
          break;
        case 4:
          textRisk = "Obesidad tipo 3";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    case "work":
      title = "Felicidad en el trabajo";
      switch (level) {
        case 0:
          textRisk = "Satisfacción alta";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Inconformidad moderada";
          colorKey = "yellow";
          break;
        case 2:
          textRisk = "Insatisfacción alta";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    case "metabolic":
      title = "Riesgo Metabólico";
      switch (level) {
        case 0:
          textRisk = "Riesgo Bajo";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Riesgo Medio";
          colorKey = "yellow";
          break;
        case 2:
          textRisk = "Riesgo Alto";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    case "activity":
      title = "Sedentarismo";
      switch (level) {
        case 0:
          textRisk = "Estilo de vida muy activa";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Estilo de vida activa";
          colorKey = "green";
          break;
        case 2:
          textRisk = "Estilo de vida poco activa";
          colorKey = "yellow";
          break;
        case 3:
          textRisk = "Estilo de vida Sedentario";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    case "lifestyle":
      title = "Estilo de vida";
      switch (level) {
        case 0:
          textRisk = "Hábitos muy saludables";
          colorKey = "green";
          break;
        case 1:
          textRisk = "Hábitos saludables";
          colorKey = "green";
          break;
        case 2:
          textRisk = "Hábitos poco saludables";
          colorKey = "yellow";
          break;
        case 3:
          textRisk = "Hábitos nada saludables";
          colorKey = "red";
          break;
        default:
          textRisk = "Desconocido";
      }
      break;

    default:
      title = "Desconocido";
      textRisk = "Desconocido";
  }

  return {
    title,
    textRisk,
    boxColor: COLOR_MAP[colorKey],
    textColor: "#000000"
  };
}
